import styled from 'styled-components';
import { P } from '@decisiv/ui-components';

const Label = styled(P)`
  margin-right: -6px;
  align-self: center;
`;

export default Label;
